import React from "react";
import PropTypes from "prop-types";

/**
 * Row 5 — the bar pinned to the bottom of every tab.
 *
 * On Overview it is the two things this screen exists to lead to: call the
 * patient, then write the prescription. On a section tab it is that section's
 * add button, which emits the section's OWN add event — the same constant its
 * in-card "+ Add" button emits, so this is a second trigger for an existing
 * path rather than a new one. Tabs with nothing sensible to add render no bar
 * at all; see ADD_EVENT_FOR_TAB in mobileConfig.
 *
 * Padded by env(safe-area-inset-bottom) in the stylesheet, so it clears the
 * home indicator on a notched phone instead of sitting under it.
 */
const MobileActionBar = ({ children }) => (
  <div className="zym-actionbar">{children}</div>
);

MobileActionBar.propTypes = { children: PropTypes.node };

export default MobileActionBar;
